var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.5H5.5H5.3541C4.33011 18.5 3.5 17.6525 3.5 16.6285C3.5 15.9433 3.88713 15.3064 4.5 15C5.11287 14.6936 5.5 14.0672 5.5 13.382V9.5C5.5 6.73858 7.73858 4.5 10.5 4.5M8.5 18.5L8.5068 18.5408C8.79141 20.2484 10.2688 21.5 12 21.5C13.7312 21.5 15.2086 20.2484 15.4932 18.5408L15.5 18.5M8.5 18.5H15.5M15.5 18.5H18.5H18.6459C19.6699 18.5 20.5 17.6525 20.5 16.6285C20.5 15.9433 20.1129 15.3064 19.5 15C18.8871 14.6936 18.5 14.0672 18.5 13.382V9.5C18.5 6.73858 16.2614 4.5 13.5 4.5M10.5 4.5V4C10.5 3.17157 11.1716 2.5 12 2.5C12.8284 2.5 13.5 3.17157 13.5 4V4.5M10.5 4.5H13.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3.5,
    fill: "#F04848",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNew);
export default __webpack_public_path__ + "static/media/notification-new.ba758713c416ce448b9a8910da7343d9.svg";
export { ForwardRef as ReactComponent };